import axios from '../axiosInstance';

export async function getVatRates({ search = '', pageSize = 50, lastId = null, signal = null } = {}) {
    const { data } = await axios.get('/VatRates/getVatRates', { params: { search, pageSize, lastId }, signal });
    return data; // { items, lastId, hasMore }
}
